import React, { useState } from 'react';
import QRScanner from '../../components/QRScanner';
import ErrorDialog from '../../components/Dialogs/ErrorDialog';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: theme.palette.common.black,
    zIndex: 1,
  },
}));

const Scan = () => {
  const classes = useStyles();
  const [error, setError] = useState<string | null>(null);

  const handleError = (msg: string) => {
    setError(msg);
  };

  const handleCloseError = () => {
    setError(null);
  };

  return (
    <div className={classes.root}>
      <QRScanner onError={handleError} />
      <ErrorDialog
        open={!!error}
        onClose={handleCloseError}
        onConfirm={handleCloseError}
        title="Scan Error"
        body={error || ''}
      />
    </div>
  );
};

export default Scan;
